import { render, staticRenderFns } from "./ReportingChartPie.vue?vue&type=template&id=e8c48e20&scoped=true&"
import script from "./ReportingChartPie.vue?vue&type=script&lang=js&"
export * from "./ReportingChartPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c48e20",
  null
  
)

export default component.exports